module.exports = __webpack_public_path__ + "img/customer-a-095.64bd86e9.png";